const createBatch = (items, value) =>
  items.reduce(
    (acc, item) => ({
      ...acc,
      [item]: value,
    }),
    {}
  );

const getOptionBatchChanges = ({ elementIds, attributes, value }) =>
  createBatch(elementIds, createBatch(attributes, value));

export default getOptionBatchChanges;
